const KEY = "flyg.recent";

export type RecentItem =
  | { type: "flight"; value: string; ts: number }
  | { type: "route"; from: string; to: string; ts: number };

export function getRecent(): RecentItem[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

type RecentInput =
  | { type: "flight"; value: string }
  | { type: "route"; from: string; to: string };

export function addRecent(item: RecentInput) {
  const list = getRecent();
  const stamped = { ...item, ts: Date.now() } as RecentItem;
  const filtered = list.filter((i) => JSON.stringify({ ...i, ts: 0 }) !== JSON.stringify({ ...stamped, ts: 0 }));
  filtered.unshift(stamped);
  localStorage.setItem(KEY, JSON.stringify(filtered.slice(0, 8)));
}